import * as React from "react";

const Icon = (props) => {
  return <i className={`icon-${props.icon}`} />;
};

export default Icon;



// WEBPACK FOOTER //
// ./src/theme/Icon.js